import queryString from 'query-string';

import { CAMPAIGN_TYPE, getCampaignType, campaignId } from 'utils/campaign';
import { PUBLIC_SHOP, COUNTRY_ISO_CODE } from 'utils/subscriptions';
import env from 'utils/env';
import request from './request';

export function getSearchTerms(loggedIn) {
  const campaignType = getCampaignType();
  const isPublicShop = !loggedIn && campaignType === CAMPAIGN_TYPE.shop;
  const api = isPublicShop ? env.publicAceApi : env.aceApi;
  const queryParams = {
    campaignType,
    ...(campaignId && { campaignId }),
    ...(isPublicShop && {
      productType: PUBLIC_SHOP,
      countryIsoCode: COUNTRY_ISO_CODE,
    }),
  };
  const headers = {
    Accept: 'application/vnd.fabfitfun.v2+json',
  };
  const requestUrl = `${api}/1/products/search-terms?${queryString.stringify(
    queryParams
  )}`;
  return request(requestUrl, 'GET', headers);
}

export function getCategories(loggedIn) {
  const campaignType = getCampaignType();
  const isPublicShop = !loggedIn && campaignType === CAMPAIGN_TYPE.shop;
  const api = isPublicShop ? env.publicAceApi : env.aceApi;
  const queryParams = {
    campaignType,
    ...(campaignId && { campaignId }),
    ...(isPublicShop && {
      productType: PUBLIC_SHOP,
      countryIsoCode: COUNTRY_ISO_CODE,
    }),
  };
  const requestUrl = `${api}/1/categories?${queryString.stringify(
    queryParams
  )}`;
  const headers = {
    Accept: 'application/vnd.fabfitfun.v2+json',
  };
  return request(requestUrl, 'GET', headers);
}

export const getCustomizeLastQuestion = () =>
  request(`${env.customize}/customize/questions/last-question`);

export function getSpecData(id) {
  return request(`${env.erosURL}/${id}.json`);
}
